import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/";
  const [form, setForm] = useState({ name: "", email: "", phone: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    const res = await register(form);
    setBusy(false);
    if (!res.ok) { setErr(res.error); return; }
    toast.success("Account created");
    navigate(next);
  };

  return (
    <div className="max-w-md mx-auto px-6 py-20">
      <div className="overline text-[var(--fm-accent)]">Open an account</div>
      <h1 className="font-display text-4xl mt-2">Join White Molar.</h1>
      <p className="text-sm text-[var(--fm-text-2)] mt-2">A few details to set you up. We bill GST to your clinic and ship pan-India.</p>
      <form onSubmit={submit} className="mt-8 space-y-4">
        <Field label="Full name" value={form.name} onChange={(v) => setForm({ ...form, name: v })} testid="register-name" required />
        <Field label="Email" type="email" value={form.email} onChange={(v) => setForm({ ...form, email: v })} testid="register-email" required />
        <Field label="Phone" type="tel" value={form.phone} onChange={(v) => setForm({ ...form, phone: v })} testid="register-phone" />
        <Field label="Password (min 6 chars)" type="password" value={form.password} onChange={(v) => setForm({ ...form, password: v })} testid="register-password" required />
        {err && <div data-testid="register-error" className="text-sm text-red-600">{err}</div>}
        <button disabled={busy} data-testid="register-submit" className="fm-btn-primary w-full">{busy ? "Creating…" : "Create account"}</button>
      </form>
      <div className="text-sm text-[var(--fm-text-2)] mt-6">
        Already have an account? <Link to={`/login${next !== "/" ? `?next=${encodeURIComponent(next)}` : ""}`} className="text-[var(--fm-primary)] underline underline-offset-4">Sign in</Link>
      </div>
    </div>
  );
}

function Field({ label, value, onChange, type = "text", testid, required }) {
  return (
    <div>
      <label className="overline">{label}</label>
      <input required={required} type={type} value={value} data-testid={testid} onChange={(e) => onChange(e.target.value)} className="w-full border border-[var(--fm-border)] mt-2 px-3 py-2.5 text-sm bg-white focus:outline-none focus:border-[var(--fm-primary)]" />
    </div>
  );
}
